<template>
<header class="audit-header">
  <nav class="audit-nav">
      <div class="nav-container">
        <h1 class="logo">
          <a href="/adminreport">동아쏘시오 그룹 사이버감사실</a>
        </h1>
        <div class="user-area">
          <span class="user"><span class="name">관리자</span> 님</span>
          <button type="button" class="logout-btn" @click="logout">로그아웃</button>
        </div>
      </div>
    </nav>
  </header>
</template>
<script>
export default {
  name: 'AdminHeader',
  methods: {
    logout () {
      if (confirm('로그아웃 하시겠습니까?')) {
        sessionStorage.removeItem('token')
        this.$router.push('/adminlogin')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.audit-header{
  padding:0;
  height:80px;
    .audit-nav{
      .logo{
        position:absolute;
        top:50%;
        margin-top:-28px;
        left:85px;
        font-size: 0;
        text-indent: -9999px;
        width: 188px;
        height: 56px;
        background: url('../img/header-logo.png') no-repeat center top;
      }
  }
}
.user-area{
  position:absolute;
  top:0;
  right:25px;
  height:100%;
  line-height:80px;
  .user{
    font-size:14px;
    background:url('../img/user-icon.png') no-repeat left center;
    padding-left:20px;
  }
  .logout-btn{
    font-size:14px;
    width:97px;
    height:32px;
    border:1px solid #ccc;
    background:#eee;
    margin-left:32px;
    vertical-align: middle;
    line-height:30px;
    color:#000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AdminHeader.vue